import { Compass } from "lucide-react";

export function Brand({ subtitle }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand">
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1E293B] text-[#F1F5F9]">
        <Compass strokeWidth={1.5} className="h-5 w-5" />
      </div>
      <div className="leading-tight">
        <div className="font-display text-lg font-semibold text-[#1E293B]">Global Compass</div>
        {subtitle && <div className="text-xs tracking-[0.2em] uppercase text-[#1E293B]/50">{subtitle}</div>}
      </div>
      <img src="/gcrc-logo.png" alt="Global Competency Research Consortium" className="ml-1 h-20 w-20 object-contain" data-testid="brand-seal" />
    </div>
  );
}
